/* eslint-disable camelcase */
import { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import { getLocalisedOpswatLink } from '@mdc/services';

import './Plan.scss';

const Plan = ({ title, className, licensingPlan, planButtons, nrOfEngines }) => {
    const [t, ready] = useTranslation();
    const planClasses = classNames({}, className);
    const spanClasses = classNames({}, 'belowInfo');
    const buttonClasses = classNames({}, 'button text-center');
    const [callToAction, setCallToAction] = useState();

    useEffect(() => setCallToAction(className === 'details' ? (
        <p className={spanClasses}>
            <span
                dangerouslySetInnerHTML={{
                    __html:
                    '<sup>1 </sup>' +
                        t(
                            'applies to file uploads and bulk requests. <a href=`https://onlinehelp.opswat.com/mdcloud/4._Throttling.html` rel="noopener noreferrer" target="_blank">See documentation</a>'
                        )
                }}
            ></span>
            <span id="footnote"><sup>2 </sup> {t('excluding archive file or recursive file processing that involve multiple file analysis even though single file is submitted for analysis. Dynamic analysis is also excluded. p50: median value of all the requests in the given month. p90: 90 percentile of all the requests in the given month')}</span>
            <span><sup>3 </sup> {t('encrypt private resources such as sanitized versions of files using customer provided public keys')}</span>
            <span><sup>4 </sup>{t('when the rate limit is exceeded, how much can the user go above before the API starts blocking requests. The exceeding requests will be processed with lower priority')}</span>

        </p>
    ) : (
        <div className={buttonClasses}>
            {planButtons[className]}
        </div>
    )), [className, planButtons, t]);

    const domLicensingPlans = useMemo(() => {
        return licensingPlan.map((plan, index) => {
            if (plan.includes(t('Response Time <sup>2</sup>')) || plan.length < 1){
                return <li key={index} className="slaAvailability" dangerouslySetInnerHTML={{ __html: plan || '-' }}/>;
            }

            if (plan.indexOf('</a>') > -1 || plan.indexOf('</sup>') > -1) {
                return <li key={index} dangerouslySetInnerHTML={{ __html: plan }}/>;
            }

            if (plan.indexOf('</ul>') > -1) {
                return <li key={index} className="slaList" dangerouslySetInnerHTML={{ __html: plan }}/>;
            }

            if (plan.includes('further increase on demand')) {
                return <li key={index} className="onDemand">{plan}</li>;
            }

            if (plan === 'freeEngines') {
                plan = nrOfEngines?.free_engines_count || '-';
            }

            if (plan === 'commercialEngines' || plan === 'enterpriseEngines') {
                plan = nrOfEngines?.commercial_engines_count || '-';
            }

            return <li key={index}>{plan}</li>;
        });
    }, [licensingPlan]);


    if (!ready) {
        return null;
    }

    return (
        <div className={planClasses}>
            <div className="planHeader">
                {title ? <p className='h5Mask'>{t(title)}</p> : ''}
            </div>
            <div className="planBody">
                <ul className="licensingPlan">{domLicensingPlans}</ul>
                {callToAction}
            </div>
        </div>
    );
};

Plan.propTypes = {
    title: PropTypes.string,
    licensingPlan: PropTypes.array,
    className: PropTypes.string,
    planButtons: PropTypes.object,
    nrOfEngines: PropTypes.object
};

Plan.defaultProps = {
    title: '',
    licensingPlan: [],
    className: '',
    planButtons: {
        'free': <a href='/'>{'Start using now'}</a>,
        'commercial': <a href='/store'>{'Buy now'}</a>,
        'enterprise': <OutboundLink href={getLocalisedOpswatLink('https://www.opswat.com/contact')} rel="noopener noreferrer" target="_blank">{'Request a quote'}</OutboundLink>
    }
};

export default Plan;
